import { useService } from "@policoders/di";
import { useEffect, useState } from "react";

import { Company } from "./company.model";
import CompanyRepository from "./company.repository";

export type ICompanyFormProps = {
  data: Company;
  onChange: (data: Company) => void;
};

export const useCompanyForm = ({ data, onChange }: ICompanyFormProps) => {
  const [state, setState] = useState<Company>(data);
  const repository = useService<CompanyRepository>("CompanyRepository");

  useEffect(() => {
    data.id &&
      repository.getById(data.id).then(value => {
        setState({ ...data, ...value });
      });
  }, [data, repository]);

  useEffect(() => {
    onChange && onChange(state);
  }, [onChange, state]);

  const handleChange = (e: any) => {
    setState({ ...state, [e.target.name]: e.target.value });
  };

  return { state, handleChange };
};
